export default ($axios) => ({
    getTermsAndConditionsData() {
        return $axios({
            method: 'GET',
            url: '/settings/terms_and_privacy_policy',
        })
    },
})